var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2C0.875 0 0 0.90625 0 2V11C0 12.125 0.875 13 2 13H6.625L6.3125 14.5H4.75C4.3125 14.5 4 14.8438 4 15.25C4 15.6875 4.3125 16 4.75 16H13.25C13.6562 16 14 15.6875 14 15.25C14 14.8438 13.6562 14.5 13.25 14.5H11.6562L11.3438 13H16C17.0938 13 18 12.125 18 11V2C18 0.90625 17.0938 0 16 0ZM10.125 14.5H7.84375L8.15625 13H9.8125L10.125 14.5ZM16.5 11C16.5 11.2812 16.25 11.5 16 11.5H2C1.71875 11.5 1.5 11.2812 1.5 11V2C1.5 1.75 1.71875 1.5 2 1.5H16C16.25 1.5 16.5 1.75 16.5 2V11Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplay);
export default __webpack_public_path__ + "static/media/display.852d39cbbf847d5205b0072160b89985.svg";
export { ForwardRef as ReactComponent };